<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <a-form-item label="Name" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterName" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="User Phone" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUser Phone" v-model="queryParam.userPhone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="CustomerPhone" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterCustomerPhone" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="UserID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUserID" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="OrderInfoID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterOrderInfoID" v-model="queryParam.orderInfoId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="TaskID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterTaskID" v-model="queryParam.taskId"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="7" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleView(record)">View Call Records</a>
        </span>
      </a-table>
      <!-- Call record modal: display call record table -->
      <a-modal v-model="callModalVisible" title="ConversationRecord" :footer="null" :width="1600" @cancel="handleModalCancel">
        <a-table
          ref="recordTable"
          rowKey="id"
          size="middle"
          :columns="recordColumns"
          :dataSource="recordDataSource"
          :pagination="recordPagination"
          :loading="recordLoading"
          :scroll="{ x: 1400 }"
          bordered
          @change="handleRecordTableChange"
        >
          <span slot="recordUrl" slot-scope="text">
            <a v-if="text" :href="text" target="_blank">{{ text }}</a>
            <span v-else>-</span>
          </span>
          <span slot="direction" slot-scope="text">
            <span v-if="text === 0 || text === '0'">Outbound</span>
            <span v-else-if="text === 1 || text === '1'">Inbound</span>
            <span v-else>-</span>
          </span>
          <span slot="through" slot-scope="text">
            <span v-if="text === true || text === 'true' || text === 1 || text === '1'">Connected</span>
            <span v-else-if="text === false || text === 'false' || text === 0 || text === '0'">Not Connected</span>
            <span v-else>-</span>
          </span>
        </a-table>
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
// getOutboundPage: Outbound call list pagination query;getOutboundRecord: Get call record pagination data
import { getOutboundPage, getOutboundRecord } from '@/webpublicapi/system'

export default {
  name: 'YunkeList',
  data() {
    return {
      // Save call record query params
      params: {},
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      dataSource: [],
      // Query conditions
      queryParam: {
        name: '',
        phone: '',
        userPhone: '',
        userId: '',
        taskId: '',
        orderInfoId: '',
      },
      loading: false,
      // Table header
      columns: [
        { title: 'UserID', align: 'left', dataIndex: 'userId', width: '140px' },
        { title: 'Name', align: 'left', dataIndex: 'name', width: '160px' },
        { title: 'User Phone', align: 'left', dataIndex: 'userPhone', width: '140px' },
        { title: 'CustomerPhone', align: 'left', dataIndex: 'phone', width: '180px' },
        { title: 'TaskID', align: 'left', dataIndex: 'taskId', width: '140px' },
        { title: 'OrderInfoID', align: 'left', dataIndex: 'orderInfoId', width: '140px' },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          width: '160px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // Modal show/hide and current row data
      callModalVisible: false,
      currentRecord: null,
      // Call record table data
      recordDataSource: [],
      recordLoading: false,
      recordPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // Call record table column config
      recordColumns: [
        { title: 'UserID', align: 'left', dataIndex: 'userId', width: '120px' },
        { title: 'User Name', align: 'left', dataIndex: 'userName', width: '120px' },
        { title: 'User Phone', align: 'left', dataIndex: 'userPhone', width: '140px' },
        { title: 'ConversationTime', align: 'left', dataIndex: 'createTime', width: '180px' },
        { title: 'CustomerPhone', align: 'left', dataIndex: 'phone', width: '140px' },
        { title: 'ConversationWhenLong', align: 'left', dataIndex: 'duration', width: '120px' },
        {
          title: 'RecordingAddress',
          align: 'left',
          dataIndex: 'recordUrl',
          width: '120px',
          scopedSlots: { customRender: 'recordUrl' },
        },
        {
          title: 'Outbound/Inbound',
          align: 'left',
          dataIndex: 'direction',
          width: '100px',
          scopedSlots: { customRender: 'direction' },
        },
        {
          title: 'Whether Answered',
          align: 'left',
          dataIndex: 'through',
          width: '100px',
          scopedSlots: { customRender: 'through' },
        },
        { title: 'Employee Outbound Call SIM Card ICCID', align: 'left', dataIndex: 'simNumber', width: '140px' },
      ],
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
    }
  },
  created() {
    this.loadData(true)
  },
  methods: {
    // Query
    searchQuery() {
      this.loadData(true)
    },
    // Reset
    searchReset() {
      this.resetQueryParam()
      this.loadData(true)
    },
    // List loading
    async loadData(resetPage = false) {
      if (resetPage) {
        this.ipagination.current = 1
      }

      this.loading = true
      const params = this.getQueryParams()

      try {
        const res = await getOutboundPage(params)
        const ok = res && (res.code === 1000 || res.code === 0)
        if (!ok) {
          this.ipagination.total = 0
          this.dataSource = []
          const msg = res && res.msg ? res.msg : 'Query failed'
          this.$message.error(msg)
          return
        }

        const data = res.data || {}
        const rows = data.rows || data.list || []
        let total = 0
        if (typeof data.total === 'number') {
          total = data.total
        } else if (Array.isArray(data.list)) {
          total = data.list.length
        }

        this.ipagination.total = total
        this.dataSource = rows
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    },
    getQueryParams() {
      const param = Object.assign({}, this.queryParam, this.isorter)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current
      this.ipagination.pageSize = pagination.pageSize
      this.loadData()
    },
    async handleView(record) {
      this.currentRecord = record
      this.callModalVisible = true
      // Save call record query params
      this.params = {
        orderInfoId: record.orderInfoId,
        phone: record.phone,
        taskId: record.taskId,
        userId: record.userId,
        userPhone: record.userPhone,
      }
      // Load call record data
      await this.loadRecordData(true)
    },
    // Load call record data
    async loadRecordData(resetPage = false) {
      if (resetPage) {
        this.recordPagination.current = 1
      }

      this.recordLoading = true
      const params = {
        ...this.params,
        pageNum: this.recordPagination.current,
        pageSize: this.recordPagination.pageSize,
      }

      try {
        const res = await getOutboundRecord(params)
        const ok = res && (res.code === 1000 || res.code === 0)
        if (!ok) {
          this.recordPagination.total = 0
          this.recordDataSource = []
          const msg = res && res.msg ? res.msg : 'Query failed'
          this.$message.error(msg)
          return
        }

        const data = res.data || {}
        const rows = data.rows || data.list || []
        let total = 0
        if (typeof data.total === 'number') {
          total = data.total
        } else if (Array.isArray(data.list)) {
          total = data.list.length
        }

        this.recordPagination.total = total
        this.recordDataSource = rows
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.recordLoading = false
      }
    },
    // Call record table pagination change
    handleRecordTableChange(pagination) {
      this.recordPagination.current = pagination.current
      this.recordPagination.pageSize = pagination.pageSize
      this.loadRecordData()
    },
    // Modal close
    handleModalCancel() {
      this.recordDataSource = []
      this.recordPagination.current = 1
      this.recordPagination.total = 0
    },
    resetQueryParam() {
      this.queryParam = {
        name: '',
        phone: '',
        userPhone: '',
        userId: '',
        taskId: '',
        orderInfoId: '',
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
